import React from "react";
import style from "./modal.module.css";
import { useNavigate } from "react-router-dom";

const Modal = ({ setShowModal }) => {
  const navigate = useNavigate();

  const handleProcess = () => {
    setShowModal(false);
    setShowModal(true);
    navigate(`/ussd-product`);
  };
  return (
    <div className={style.overlay}>
      <div className={style.modalContent}>
        <p className={style.headerText}>Order has been treated</p>
        <div className={style.centeredButtonContainer}>
          <div className={style.button} onClick={handleProcess}>
            <p className={style.buttonText}>Continue</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
